import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRefreshKlaviyoListsMutation = createMutationHook(
  CreatorIntegrationsApiClient.refreshKlaviyoLists,
  {
    mutationKey: ['refreshKlaviyoLists'],
  },
)
